import { Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { Rutas } from '@/constants/rutas';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const PredictingPromotionIcon = ({ sx = {} }) => {
    const router = useRouter();

    const handleClick = () => {
        router.push(Rutas.PREDICCIONES_FANTASY);
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                position: 'absolute',
                bottom: '22px',
                right: '5px',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                padding: '2px 4px',
                borderRadius: '8px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                '&:hover': {
                    transform: 'translateY(-2px) scale(1.05)',
                    boxShadow: '0 4px 16px rgba(102, 126, 234, 0.7)',
                    animation: 'none',
                },
                '@keyframes bounceAttention': {
                    '0%, 15%, 100%': {
                        transform: 'translateY(0) scale(1)',
                        opacity: 1,
                    },
                    '3%': {
                        transform: 'translateY(-8px) scale(1.1)',
                        opacity: 1,
                    },
                    '6%': {
                        transform: 'translateY(0) scale(1)',
                        opacity: 1,
                    },
                    '9%': {
                        transform: 'translateY(-4px) scale(1.05)',
                        opacity: 1,
                    },
                    '12%': {
                        transform: 'translateY(0) scale(1)',
                        opacity: 1,
                    },
                },
                '@keyframes glow': {
                    '0%, 15%, 100%': {
                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    },
                    '3%, 6%, 9%, 12%': {
                        boxShadow: '0 0 20px rgba(102, 126, 234, 0.8), 0 0 30px rgba(118, 75, 162, 0.6)',
                    },
                },
                animation: 'bounceAttention 10s ease-in-out infinite, glow 10s ease-in-out infinite',
                ...sx,
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    color: '#fff',
                    fontWeight: 4600,
                    fontSize: 10,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                }}
            >
                Predicting Fantasy
            </Typography>
        </Box>
    );
};

export default PredictingPromotionIcon;
